import { takeLatest, call, select, put } from 'redux-saga/effects';

// Services
import { segmentationsApi } from 'services/apiDigitalTicket/segmentations';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';
import SEGMENTATION_TYPE from 'constants/segmentations';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as AnomaliesActions from './actions';

// Types
import { AnomaliesTypes } from './types';

function* listAnomalies({
  payload,
}: ReturnType<typeof AnomaliesActions.listAnomaliesRequest>): any {
  try {
    const { body } = payload;
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando Irregularidades' }));

    const transportOperator = yield select(
      (state: any) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(segmentationsApi.get, {
      params: {
        transportOperatorId: transportOperator.id,
        type: SEGMENTATION_TYPE.ANOMALY,
        ...body,
      },
    });

    if (response.status === 200) {
      yield put(
        AnomaliesActions.listAnomaliesSuccess({
          anomalies: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('anomalies - listAnomalies - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(AnomaliesActions.listAnomaliesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* listAnomalyUsers({
  payload,
}: ReturnType<typeof AnomaliesActions.listAnomalyUsersRequest>): any {
  try {
    const { id, body } = payload;
    yield put(
      DialogsActions.setOpenLoading({ title: 'Carregando usuários' }),
    );

    const response = yield call(segmentationsApi.listUsers, {
      params: { id, ...body },
    });

    if (response.status === 200) {
      yield put(
        AnomaliesActions.listAnomalyUsersSuccess({
          anomalyUsers: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('anomalies - listAnomalyUsers - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(AnomaliesActions.listAnomalyUsersFailure());
    yield put(DialogsActions.setClose());
  }
}

export const anomaliesSagas = [
  takeLatest(AnomaliesTypes.LIST_ANOMALIES_REQUEST, listAnomalies),
  takeLatest(AnomaliesTypes.LIST_ANOMALY_USERS_REQUEST, listAnomalyUsers),
];
